import React, { useState, useEffect } from 'react';
import './Testimonials.scss';

const Testimonials: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Tainara Toledo',
      role: 'Loja de Cosméticos Online',
      avatar: '👩‍💼',
      text: 'Nunca imaginei que emitir nota fiscal pudesse ser tão simples. O suporte é incrível e sempre que preciso, consigo ajuda rápida pelo WhatsApp. Recomendo de olhos fechados!',
      rating: 5
    },
    {
      id: 2,
      name: 'Luan Bruno',
      role: 'Loja de Roupas Masculinas',
      avatar: '👨‍🍳',
      text: 'Antes eu passava horas tentando organizar tudo em planilhas. Com o 77Gestão, consigo ver minha situação financeira em segundos. Economizo pelo menos 10 horas por semana!',
      rating: 5
    },
    {
      id: 3,
      name: 'Rodrigo Souza',
      role: 'Empreiteiro',
      avatar: '👩‍💻',
      text: 'Indico o 77Gestão para todos os meus clientes. O sistema é intuitivo, completo e o preço cabe no bolso de pequenas empresas. Facilitou muito minha rotina.',
      rating: 5
    },
    {
      id: 4,
      name: 'Margarida Braz',
      role: 'Serviços de Limpeza',
      avatar: '👨‍💼',
      text: 'Com o bot do WhatsApp recebo os números do dia toda manhã automaticamente. Tomei decisões mais rápidas e aumentei meu lucro em menos de 3 meses.',
      rating: 5
    },
    {
      id: 5,
      name: 'Claudia Silva',
      role: 'Confeiteira',
      avatar: '👩‍🔬',
      text: 'Migrar do Excel para o 77Gestão foi a melhor decisão que tomei. Nunca mais perdi um pagamento ou esqueci de cobrar um cliente. Tudo fica organizado e eu durmo tranquila.',
      rating: 5
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="depoimentos" className="testimonials">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <h2>Quem usa, aprova</h2>
          <p>Veja o que nossos clientes têm a dizer</p>
        </div>

        <div className="testimonials-carousel">
          <button className="carousel-btn prev" onClick={prevSlide} aria-label="Anterior">
            <i className="fas fa-chevron-left"></i>
          </button>

          <div className="testimonials-track">
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className={`testimonial-card ${index === currentIndex ? 'active' : ''} ${
                  index === (currentIndex - 1 + testimonials.length) % testimonials.length ? 'prev' : ''
                } ${index === (currentIndex + 1) % testimonials.length ? 'next' : ''}`}
              >
                <div className="testimonial-content">
                  <div className="quote-icon">
                    <i className="fas fa-quote-left"></i>
                  </div>
                  
                  <div className="rating">
                    {Array.from({ length: testimonial.rating }).map((_, i) => (
                      <i key={i} className="fas fa-star"></i>
                    ))}
                  </div>

                  <p className="testimonial-text">{testimonial.text}</p>

                  <div className="testimonial-author">
                    <div className="author-info">
                      <h4>{testimonial.name}</h4>
                      <p>{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className="carousel-btn next" onClick={nextSlide} aria-label="Próximo">
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>

        <div className="carousel-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Ir para depoimento ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
